import HLayout from "./components/h-layout";
import HEditor from "./components/h-editor";
import TEditor from "./components/t-editor";
import Echars from "./components/e-chars";
import HText from "./components/h-text";
export * from "./components/h-layout";

import HPagination from "./components/h-pagination";

import HContainer from "./components/h-container";
import HRouterView from "./components/h-router-view/index.vue";
export * from "./utils/notification";

export * from "./hooks";

import mitter from "./utils/mitter";
export {mitter};


export * from "./hooks/time-from";

const install = (Vue: any) => {
    for (const key in components) {
        Vue.component(key, components[key]);
    }
}
const components: any = {
    HLayout,
    HContainer,
    HRouterView,
    HPagination,
    HText
};

if (typeof window !== 'undefined' && (window as any).Vue) {
    install((window as any).Vue);
}

export default {
    install
}

export {
    HLayout,
    HContainer,
    HRouterView,
    HPagination,
    HEditor,
    TEditor,
    Echars,
    HText
};